/**
 * PEOPLE STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getPeople,
    getPerson,
    printPerson,
    createPeople,
    updatePeople,
    deletePeople,
    updatePeoplePhoto,
    requestLoginAsUser,
} from "Core/people/config/api.people";

const state = {
    page: {},
    form: {},
    people: [],
    person_options: [],
    selectedPerson: {
        people_id: null,
        company_id: "",
        person_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        person_details: [],
    },
    people_filter: {
        search: null,
        login_type: null,
        has_user_account: null,
        company_id: null,
        page_size: 2,
        page_num: 1,
    },
    rules_people: {
        people_id: {
            name: "people_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        prefix: {
            name: "prefix",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        first_name: {
            name: "first_name",
            rules: "trim|max_length[35]",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        middle_name: {
            name: "middle_name",
            rules: "trim|max_length[35]",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        last_name: {
            name: "last_name",
            rules: "trim|max_length[35]",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        suffix: {
            name: "suffix",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        combined_name: {
            name: "combined_name",
            rules: "trim|max_length[120]",
            max_len: "120",
            min_len: "",
            default_value: "",
        },
        nick_name: {
            name: "nick_name",
            rules: "trim|max_length[35]",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        job_title: {
            name: "job_title",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        gender: {
            name: "gender",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        photo_id: {
            name: "photo_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        photo: {
            name: "photo",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        entity_phones_id: {
            name: "entity_phones_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        entity_emails_id: {
            name: "entity_emails_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        battery_notify: {
            name: "battery_notify",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        user_time_zone: {
            name: "user_time_zone",
            rules: "trim|max_length[35]|required",
            max_len: "35",
            min_len: "",
            default_value: "America/Detroit",
        },
        unit_of_measure: {
            name: "unit_of_measure",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        theme: {
            name: "theme",
            rules: "trim|max_length[45]|required",
            max_len: "45",
            min_len: "",
            default_value: "default",
        },
        notification_method: {
            name: "notification_method",
            rules: "trim|max_length[8]|required",
            max_len: "8",
            min_len: "",
            default_value: "none",
        },
        language: {
            name: "language",
            rules: "trim|max_length[36]|required",
            max_len: "36",
            min_len: "",
            default_value: "english",
        },
        invite_token: {
            name: "invite_token",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        invite_expires: {
            name: "invite_expires",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        // email_address: {
        //     name: "email_address",
        //     rules: "trim|max_length[100]|valid_email|required",
        //     max_len: "100",
        //     min_len: "",
        //     default_value: "",
        // },
    },
    rules_person: {
        first_name: {
            name: "first_name",
            rules: "trim|max_length[35]|required",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        middle_name: {
            name: "middle_name",
            rules: "trim|max_length[35]",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        last_name: {
            name: "last_name",
            rules: "trim|max_length[35]|required",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        nick_name: {
            name: "nick_name",
            rules: "trim|max_length[35]",
            max_len: "35",
            min_len: "",
            default_value: "",
        },
        job_title: {
            name: "job_title",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },

        users: {
            username: {
                name: "username",
                rules: "trim|max_length[100]|valid_username|required",
                max_len: "100",
                min_len: "8",
                default_value: "",
            },
            password: {
                name: "password",
                rules: "trim|max_length[255]|required",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            confirm_password: {
                name: "confirm_password",
                rules: "trim|max_length[255]|required",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            login_type_id: {
                name: "login_type_id",
                rules: "trim|max_length[1]|integer|required",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
            default_company_id: {
                name: "default_company_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
        },
        entity_phones: {
            phone_number: {
                name: "phone_number",
                rules: "trim|max_length[15]|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            country_id: {
                name: "country_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
        },
        entity_emails: {
            email_address: {
                name: "email_address",
                rules: "trim|max_length[100]|valid_email|required",
                max_len: "100",
                min_len: "",
                default_value: "",
            },
            email_type: {
                name: "email_type",
                rules: "trim|max_length[45]|required",
                max_len: "45",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    people: (state) => {
        return state.people;
    },
    person: (state) => {
        return state.selectedPerson;
    },
};

// actions
const actions = {
    async fetchPeople({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getPeople({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "person_options",
                        with: response.data.people,
                    });
                } else {
                    commit("mutate", {
                        property: "people",
                        with: response.data.people,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchPerson({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getPerson(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedPerson",
                    with: response.data.person,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printPerson({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printPerson(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async savePerson({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["people_id"] === "undefined" || body["people_id"] == null || body["people_id"] == "") {
                delete body["people_id"];
                response = await createPeople({ body: body, headers: config.headers });
            } else {
                let people_id = body["people_id"];
                delete body["people_id"];
                response = await updatePeople({ body: body, headers: config.headers }, people_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log(error);
            console.log("save error");
            return;
        }
    },
    async deletePerson({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deletePeople(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
    async loginAsUser({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await requestLoginAsUser(payload.id);

            if (typeof response !== "undefined" && response.data) {
                let loggedInUser = response.data.user;

                let original_drawer = localStorage.getItem("drawer");
                let original_dashboard_original_layout = localStorage.getItem("dashboard_original_layout");
                let original_dashboard_layout = localStorage.getItem("dashboard_layout");
                let original_token = $cookies.get("token");
                let original_current_user = localStorage.getItem("current_user");
                localStorage.setItem("original_drawer", original_drawer);
                localStorage.setItem("original_dashboard_original_layout", original_dashboard_original_layout);
                localStorage.setItem("original_dashboard_layout", original_dashboard_layout);
                $cookies.set("original_token", original_token);
                localStorage.setItem("original_current_user", original_current_user);

                localStorage.setItem("drawer", "true");
                localStorage.setItem(
                    "dashboard_original_layout",
                    loggedInUser.dashboard_layout === null ? JSON.stringify({ children: [] }) : JSON.stringify(loggedInUser.dashboard_layout)
                );
                localStorage.setItem(
                    "dashboard_layout",
                    loggedInUser.dashboard_layout === null ? JSON.stringify({ children: [] }) : JSON.stringify(loggedInUser.dashboard_layout)
                );
                $cookies.set(
                    "token",
                    { token: response.data.token, token_expires: response.data.token_expires },
                    new Date(response.data.token_expires).toUTCString(),
                    null,
                    null,
                    true,
                    "Strict"
                );
                localStorage.setItem("current_user", JSON.stringify(loggedInUser));

                // refresh webpage
                location.reload();
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    updateUserObject(state, data) {
        state.selectedPerson["user"] = data;
    },
    resetPeople(state) {
        state.page = {};
        state.form = {};
        state.people = [];
        state.person_options = [];
        state.selectedPerson = {
            people_id: null,
            company_id: "",
            person_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            person_details: [],
        };
        state.people_filter = {
            search: null,
            login_type: null,
            has_user_account: null,
            company_id: null,
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
